import Modal from "@/common/components/Modal";
import SmallBadge from "@/common/components/SmallBadge";
import { BellPlusIcon } from "lucide-react";
import { useState } from "react";
import { useMaintenanceEstablishmentChoiceAuctionEntryFollow } from "../../../hooks/useMaintenanceEstablishmentChoiceAuctionEntryFollow";
import useModalMessagesSimple from "@/common/hooks/useModalMessagesSimple";
import { useQueryClient } from "@tanstack/react-query";

interface FollowAuctionProps {
  auctionEntryId: string | undefined;
}

const FollowAuction = ({
  auctionEntryId,
}: FollowAuctionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const queryClient = useQueryClient();

  const {
    setMessages
  } = useModalMessagesSimple({
    isError: true,
  });

  const {
    mutate: follow,
    isPending: followIsPending,
  } = useMaintenanceEstablishmentChoiceAuctionEntryFollow({
    auctionEntryId,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: ['maintenanceEstablishmentChoiceAuctionEntryUpdatedSummary', auctionEntryId],
        });

        setIsOpen(false);
      },
      onError: (error) => {
        setMessages(error, { errorResponse: true });
      }
    }
  });

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      triggerAsChild
      Trigger={(
        <SmallBadge
          LeftIcon={BellPlusIcon}
          text="Acompanhar"
          className="bg-success-secondary hover:bg-success-hover transition-colors cursor-pointer"
        />
      )}
      bodyClassName='max-h-[calc(90vh-72px-48px)] overflow-auto'
      title="Acompanhar leilão?"
      titleClass="text-2xl"
      subtitleClassName="text-base mt-1"
      useCancellableFooter
      className="rounded-lg overflow-hidden"
      cancelButtonClassName="bg-white-100 rounded-es-lg"
      confirmButtonClassName="bg-primary-blue rounded-ee-lg"
      confirmButtonIsLoading={followIsPending}
      disabled={followIsPending || !auctionEntryId}
      showClose={false}
      onConfirm={() => follow()}
      preventAutoFocus
    />
  );
}

export default FollowAuction;
